module.exports = "/ui/6eddd32c198c6215faa74d3a5ebd31cb.png";